// import { API } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ContainerContent from "../Container/ContainerContent";
import LoadingPage from "../Loading/LoadingPage";
import GroupTable from "./footage/leasing.f.groupTable";
import Groups from "./footage/leasing.f.groups";
import { Dialog } from "@headlessui/react";
import { Tabs, Tab } from "../BuroBug/layer/wrapper";
import { IconDashboard, IconList } from "../BuroBug/layer/wrapper";
import classNames from "classnames";
import { useParams } from "react-router-dom";
import API from "./api/api.main"

function LeasingSettingGroup() {
  const { user } = useSelector((state) => state.initializeApp);
  const params = useParams();
  const [tab, setTab] = useState("M");

  if (params?.category === "TF") {
    return (
      <ContainerContent>
        <Groups label="กลุ่มลูกค้า (เช่าซื้อ)" type="ALL" category={"TF"} />
      </ContainerContent>
    );
  }

  return (
    <ContainerContent>
      <Tabs>
        <Tab
          tab={tab}
          setTab={setTab}
          tabValue="M"
          name="จักรยานยนต์"
          icon={IconDashboard}
        />
        <Tab
          tab={tab}
          setTab={setTab}
          tabValue="C"
          name="รถยนต์"
          icon={IconList}
        />
      </Tabs>
      <div>
        {" "}
        {tab === "M" && (
          <Groups
            label="จำนำทะเบียนจักรยานยนต์"
            type="MOTORBIKE"
            category={"NTF"}
          />
        )}
        {tab === "C" && (
          <Groups label="จำนำทะเบียนรถยนต์" type="CAR" category={"NTF"} />
        )}
      </div>
    </ContainerContent>
  );
}

export default LeasingSettingGroup;
